import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import './AnimatedSection.css';

const AnimatedSection = ({ 
  children, 
  className = '', 
  direction = 'fade',
  delay = 0,
  split = false,
  id 
}) => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <section
      ref={ref}
      id={id}
      className={`animated-section ${className} ${split ? 'split-section' : ''} ${isVisible ? 'visible' : ''}`}
      style={{ '--delay': `${delay}ms` }}
      data-direction={direction}
    >
      {children}
    </section>
  );
};

export default AnimatedSection;

